/**
 * APIクライアントのエクスポート
 */

// 統一されたAPIクライアント
export {
  authAPI, // 認証関連
  userAPI, // ユーザー情報関連
  profileAPI, // プロフィール関連
  notificationAPI, // 通知関連
  dashboardAPI, // ダッシュボード関連
  companyAPI, // 会社情報関連
  addressAPI, // 住所関連
  testAPI, // テスト用
  employeeAssignmentAPI, // 従業員配置管理関連
  overtimeRequestAPI, // 残業申請管理関連
  settingsAPI, // 設定関連
  visitAPI, // 来店受付関連
  menuAPI, // メニュー関連
  orderAPI, // オーダー関連
  storeAPI, // 店舗関連
  employeeAPI, // 従業員関連
  operationLogAPI, // 操作ログ関連
  accountingAPI, // 会計関連
  customerAPI, // 顧客管理関連
  extensionRequestAPI, // Phase2: 延長リクエスト関連
  type ExtensionRequestStatus,
  type ExtensionRequestResource,
  type OperationLog,
  type OperationLogCreateRequest,
  type OperationLogListResponse,
} from './client';

